import { Button, Divider, Grid, IconButton, Paper, Typography } from '@material-ui/core';
import React from 'react';
import { FaTimes } from 'react-icons/fa';
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { tourStyles } from './styles';

const FormTour = ({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
  styles,
  isLastStep,
  size,
  steps,
  setRun,
  onFinish,
}) => {
  const { close } = step.locale;

  const classes = tourStyles();

  const output = {
    primary: close,
  };

  if (continuous) {
    output.primary = isLastStep ? 'Finalizar' : 'Próximo';
  }

  return (
    <Grid container {...tooltipProps}>
      <Paper elevation={3} className={`w-full mt-20 max-w-512 px-8 py-4 rounded-8 ${classes.container}`}>
        <Grid item style={{ textAlign: 'end' }}>
          <IconButton
            className={classes.buttonClose}
            onClick={(e) => {
              setRun(false);
              onFinish();
            }}
          >
            <FaTimes size={16} color="black" />
          </IconButton>
        </Grid>

        {step && step.title && (
          <Grid item className={classes.title}>
            <h1>{step.title}</h1>
          </Grid>
        )}
        <Grid item className={classes.content}>
          <p dangerouslySetInnerHTML={{ __html: step.content }} />
        </Grid>

        {step.showProgress && (
          <Grid item className={classes.containerPaginacao}>
            {steps.map((item, indice) => {
              return indice !== index ? (
                <div className={classes.pontoPaginacao} />
              ) : (
                <div className={classes.elipsePaginacao} />
              );
            })}
          </Grid>
        )}

        <Divider className={classes.divider} />

        <Grid item>
          {index > 0 && (
            <Button variant="contained" onClick={backProps.onClick} className={classes.buttonVoltar}>
              <Typography>Voltar</Typography>
            </Button>
          )}

          {continuous && (
            <Button variant="contained" onClick={primaryProps.onClick} className={classes.buttonProximo}>
              <Typography>{output.primary}</Typography>
            </Button>
          )}
        </Grid>
      </Paper>
    </Grid>
  );
};

const Tour = ({ steps, run, setRun, onFinish = () => {}, disableScrolling }) => {
  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;

    const centerDiv = (element) => {
      const elementRect = element.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - window.innerHeight / 2;
      window.scrollTo(0, middle);
    };

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      if (action === ACTIONS.NEXT || action === ACTIONS.PREV) {
        let t = null;

        if (action === ACTIONS.NEXT) {
          t = steps[index + 1];
        } else if (action === ACTIONS.PREV) {
          t = steps[index - 1];
        }

        if (!t) return;
        const a = document.querySelector(t.target);
        centerDiv(a);
      }

      // Update state to advance the tour
      //this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false, so we can restart if we click start again.
      // this.setState({ run: false });
      setRun(false);
      onFinish();
    }
  };
  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showProgress
      // floaterProps={{
      //   autoOpen: true,
      // }}
      tooltipComponent={(props) => <FormTour {...props} steps={steps} setRun={setRun} onFinish={onFinish} />}
      disableOverlayClose
      disableScrolling={disableScrolling}
      disableCloseOnEsc
      scrollOffset={120}
      scrollToFirstStep
      disableScrollParentFix
      callback={handleJoyrideCallback}
      styles={{
        options: {
          primaryColor: '#5890AA',
          width: 500,
        },
      }}
    />
  );
};

export default Tour;
